import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import Link from 'libs/router/Link';

import { __t, applyTranslations } from 'utils/language';
import { getTruncatedDisplayDateAndTime } from 'utils/date';

import './notifications-dropdown.scss';

applyTranslations(require('./notifications-dropdown.i18n.json'));

import { CampaignType } from 'types';

export type NotificationsDropdownItem = {
  title: string,
  subtitle: string,
  datetime: string,
  id: string,
  new?: boolean,
  campaignId: number,
  campaignType: CampaignType,
  subcampaignId: number,
  externalConversationId?: string
};

type Props = {
  isBrand: boolean,
  onClick: () => void,
  items: Array<NotificationsDropdownItem>
};

type State = {};

class NotificationsDropdown extends React.PureComponent<Props, State> {
  render() {
    const { items, isBrand, onClick } = this.props;

    return (
      <div className="notifications-dropdown">
        <div className="notifications-dropdown__header">
          <span>{__t('notifications_dropdown.notifications_title')}</span>
        </div>
        <div className="notifications-dropdown__content">
          {
            items.length === 0 ? (
              <div className="notifications-dropdown__empty">
                {__t('notifications_dropdown.empty_label')}
              </div>
            ) : (
              items.map(item => {
                const isCcm = item.campaignType === 'ccm';

                const itemClasses = classnames({
                  'notifications-dropdown__item': true,
                  'notifications-dropdown__item--new': item.new
                });

                const queryParams = isNil(item.externalConversationId)
                  ? ''
                  : `?externalConversationId=${item.externalConversationId}`;
                const url = isBrand
                  ? `/campaigns${isCcm ? '/ccm' : ''}/${item.campaignId}/messages${queryParams}`
                  : `/campaigns/${item.campaignId}/details/${item.subcampaignId}/messages`;

                return (
                  <div onClick={onClick} key={`notifications-dropdown-${item.campaignId}`}>
                    <Link
                      className={itemClasses}
                      key={`notifications-dropdown-item-${item.id}`}
                      to={url}
                    >
                      <div className="notifications-dropdown__item-titles">
                        <div
                          className="notifications-dropdown__item-title text-overflow-ellipsis"
                          title={item.title}
                        >
                          {item.title}
                        </div>
                        <div className="notifications-dropdown__item-subtitle">
                          {item.subtitle}
                        </div>
                      </div>
                      <div className="notifications-dropdown__item-datetime">
                        {getTruncatedDisplayDateAndTime(item.datetime)}
                      </div>
                    </Link>
                  </div>
                );
              })
            )
          }
        </div>
      </div>
    );
  }
}

export default NotificationsDropdown;
